import { Box, Icon, Text } from '@nimbus-ds/components';
import { ArrowRightIcon } from '@nimbus-ds/icons';
import { PlansListResponseDto } from '@tiendanube/common';
import { useFrequencyTranslation } from 'domains/Billing/Checkout/hooks';
import { useFormatCurrency } from 'domains/Billing/hooks';

interface PlanChangeVisualProps {
  firstPlan: PlansListResponseDto;
  secondPlan: PlansListResponseDto;
}

function PlanDisplay({ plan }: Readonly<{ plan: PlansListResponseDto }>) {
  const { getFrequencyInterval } = useFrequencyTranslation();
  const formatCurrency = useFormatCurrency();

  return (
    <>
      <Text fontWeight="bold">{plan.name}</Text>
      <Text>
        {`${formatCurrency(
          plan.price.value,
          plan.price.currency,
        )} / ${getFrequencyInterval({
          recurringFrequency: 'M',
          recurringInterval: 1,
        })}`}
      </Text>
    </>
  );
}

export default function PlanChangeVisual({
  firstPlan,
  secondPlan,
}: Readonly<PlanChangeVisualProps>) {
  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between">
      <Box display="flex" flexDirection="column">
        <PlanDisplay plan={firstPlan} />
      </Box>
      <Icon source={<ArrowRightIcon size="large" />} />
      <Box display="flex" flexDirection="column" alignItems="flex-end">
        <PlanDisplay plan={secondPlan} />
      </Box>
    </Box>
  );
}
